import React, { useState } from "react";
import Toast from '../../Components/Toast/Toast'
import SplashScreen from "../SplashScreen/SplashScreen";
import LightSpeed from 'react-reveal/LightSpeed';
import { useAuthDispatch, useAuthState } from "../../Helper/Context/context";
import { loginUser } from "../../Helper/Context/action";
import { useNavigate } from "react-router-dom";

export default function Login() {

  const navigate = useNavigate()

  const dispatch = useAuthDispatch()
  const userDetails = useAuthState();
  const { UserID, token, RoleID } = userDetails

  const [userName, setuserName] = useState("")
  const [password, setpassword] = useState("")
  const [loading, setloading] = useState(false)
  const [Validationerror, setValidationerror] = useState(false)
  const [Loginmessage, setLoginmessage] = useState('')

  const handleSubmit = async (e) => {
    setLoginmessage('')
    // e.preventDefault()
    if (userName !== '' && password !== '') {
      try {
        let response = await loginUser(dispatch, { userName, password, setloading, handleRollIdWiseDashboard, handleErrorIdWiseDashboard, setLoginmessage });
        if (!response) return;
        // navigate('/dashboard');

      } catch (error) {
        console.log(error);
      }
      setValidationerror("")
    } else {
      setValidationerror("Error")
    }

  }
  const handleRollIdWiseDashboard = (data) => {
    // console.log('Data', data.RoleID)
    if (data.RoleID == 5) {
      navigate(`/AdminDashboard`)
    } else if (data.RoleID == 1) {
      navigate(`/Dashboard`)
    }
    else if (data.RoleID == 6) {
      navigate(`/PlantationDashboard`)
    }
  }


  const handleErrorIdWiseDashboard = (data) => {
    setLoginmessage(data)
  }

  const showPass = () => {
    var x = document.getElementById("pass");
    var y = document.getElementById("eye");
    console.log("X", y)
    if (x.type === "password") {

      x.type = "text";
    } else {
      x.type = "password";
    }
    if (y.className === "fas fa-eye") {
      y.className = "fas fa-eye-slash";
    } else {
      y.className = "fas fa-eye";
    }

  }

  const showPassEncrypt = () => {
    var x = document.getElementById("pass");
    x.type = "password";
  }

  return (
    <>

      <div className="container-fluid image-background containers ">
        <div className="login-page">
          <div className="row ">
            <div className="col-12">
              <h2 className="text-white text-center pb-0 pb-lg-3 pt-4 pt-lg-0">Rubber Plantation Monitoring Module</h2>
            </div>
          </div>

          <div className=" row  mx-auto background_login_page p-2 p-lg-5 w-100">
            <div className="col-lg-6 " style={{ borderRight: '1px solid #333333' }}>
              <LightSpeed left>
                <div className="row justify-content-center px-3 mt-4 pt-lg-4 ">
                  <img id="logo" src="assets/img/ey-logo1.png" />
                </div>
              </LightSpeed>
              <h5 className="pt-5 fw-bold text-center text-dark text-size"><span className="fw-bold text-dark text-size">INDIAN NATURAL RUBBER OPERATIONS</span>  <br /> FOR ASSISTED DEVELOPMENT</h5>
            </div>


            <div className="col-lg-6  px-lg-5">

              <h3 className="mb-3 text-center heading"></h3>
              <div className="form-group">
                <label className="form-control-label text-black">
                  Username
                </label>
                <input
                  type="text"
                  id="email"
                  name="userName"
                  placeholder="Phone no or email id"
                  className="form-control-login"
                  // onKeyDown={handlekeyChange}
                  value={userName}
                  onChange={(e) => setuserName(e.target.value)}
                />
              </div>

              <div className="form-group">
                <label className="form-control-label text-black">
                  Password
                </label>
                <div className="input-group-prepend">
                  <input
                    type="text"
                    id="pass"
                    name="psw"
                    placeholder="Password"
                    className="form-control-login"
                    autoSave="none"
                    autoComplete="new-password"
                    required autocomplete="current-password"
                    value={password}
                    onChange={(e) => {
                      setpassword(e.target.value)
                      showPassEncrypt()
                    }}
                  />
                  <span className="eye-icons">
                    <i
                      onClick={() => showPass()}
                      id="eye"
                      className="fas fa-eye"
                    ></i>
                  </span>
                </div>
              </div>

              <div className="row  my-2">
                <a href="#">
                  <small className="text-black float-end ">Forgot Password?</small>
                </a>
              </div>
              <div className="row justify-content-center my-3 px-3">
                <button
                  type="button"
                  className="btn-block btn-color"
                  onClick={handleSubmit}
                >
                  Login
                </button>
              </div>
              <div className="my-3 fs-7 ">
                <a className="text-danger text-center"> {Loginmessage}</a>
              </div>

            </div>

          </div>
        </div>
      </div>
    </>
  );
}
